import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export default function setupControls(camera: THREE.Camera, renderer: any) {
  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.screenSpacePanning = false;
  controls.minDistance = 2;
  controls.maxDistance = 10;
  controls.maxPolarAngle = Math.PI / 2 - 0.05;
  controls.enableZoom = true;
  controls.zoomSpeed = 0.2;
  return controls;
}

export function enableMouseLock() {
  const canvas = document.getElementsByTagName('canvas')[0] as HTMLCanvasElement;
  const lockPointer = () => {
    canvas.requestPointerLock();
    document.body.style.cursor = 'none';
  };
  canvas.addEventListener('click', lockPointer);
  document.addEventListener('pointerlockchange', () => {
    if (document.pointerLockElement !== canvas) {
      disableMouseLock();
    }
  });
}

export const disableMouseLock = () => {
  (document as any).exitPointerLock();
  document.body.style.cursor = 'default';
};

